import React, { useState, useEffect } from "react";
import "./diwaliBannerCommingSoon.scss";
import { Link } from "react-router-dom";
import MetaDecorator from "../../../componentsnew/MetaDecorator/MetaDecorator";
import {
  biggestdhamaka1,
  diwaliBanner2025_img,
  diwaliBanner2025_1100_img,
  diwaliBanner2025_1440_img,
  diwaliBanner2025_650_img,
  diwaliBannerMb2025_img,
} from "../../../images";
import useWindowDimensions from "../../../useWindowDimensions";
import Diwaliheader from "../DiwaliHeader/Diwaliheader";
import DiwaliFooter from "../DiwaliFooter/DiwaliFooter";
import AOS from "aos";
import "aos/dist/aos.css";

const DiwaliBannerCommingSooon = () => {
  const { width } = useWindowDimensions();

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <MetaDecorator
        metaTitle="Laxmi (HOS) - Golden Jubilee Bonanza Khushiyo ki diwali inamo ki fhuljadi"
        metaDesc="Enter Coupon Code for a chance to win prizes upto 20,000 USD in Laxmi's Golden Jubilee Bonanza."
        canonicalLink={window.location.href}
        nonindexable={true}
      />
      <Diwaliheader />
      <main className="diwali_2025_main_com">
        <section
          className="diwali_sec1"
          data-aos="fade"
          data-aos-duration="1500"
        >
          <div className="banner_wrapper">
            {width > 767 ? (
              <picture>
                <source
                  media="(min-height: 1440px)"
                  srcSet={diwaliBanner2025_1440_img}
                />
                <source
                  media="(min-height: 1100px)"
                  srcSet={diwaliBanner2025_1100_img}
                />
                <source
                  media="(min-height: 1080px)"
                  srcSet={diwaliBanner2025_650_img}
                />
                <source
                  media="(min-height: 1023px)"
                  srcSet={diwaliBanner2025_1100_img}
                />
                <source
                  media="(min-height: 1003px)"
                  srcSet={diwaliBanner2025_650_img}
                />
                <source
                  media="(min-height: 953px)"
                  srcSet={diwaliBanner2025_650_img}
                />
                <source
                  media="(min-height: 800px)"
                  srcSet={diwaliBanner2025_1100_img}
                />
                <source
                  media="(min-height: 500px)"
                  srcSet={diwaliBanner2025_650_img}
                />

                <source
                  media="(max-width: 1200px)"
                  srcSet={diwaliBanner2025_img}
                />
                <source
                  media="(max-width: 767px)"
                  srcSet={diwaliBannerMb2025_img}
                />

                <img
                  src={diwaliBanner2025_img}
                  alt="Landing page banner"
                  className="banner_img"
                  width={width > 767 ? "1920" : "375"}
                  height={width > 767 ? "960" : "752"}
                  loading="eager"
                />
              </picture>
            ) : (
              <img
                src={diwaliBannerMb2025_img}
                alt="Landing page banner"
                className="banner_img"
                width={"375"}
                height={"752"}
                loading="eager"
              />
            )}
            {/* <img
              src={width > 767 ? diwaliBanner2025_img : diwaliBannerMb2025_img}
              alt="Landing page banner"
              className="banner_img"
              width={width > 767 ? "1920" : "375"}
              height={width > 767 ? "960" : "752"}
              loading="eager"
            /> */}
          </div>
        </section>
        {/* <GoToTop /> */}
      </main>
      <DiwaliFooter />
    </>
  );
};

export default DiwaliBannerCommingSooon;
